// @flow
export { default } from './InlineNotice';
